import { Injectable } from '@angular/core';
import { Message, MessagePostRequest, Location, MessageKind } from '@clientwire/api';

@Injectable({
  providedIn: 'root',
})
export class MessageStoreHelperService {
  createNewMessage(
    tenantId: string,
    conversationId: string,
    participantId: string,
    kind: MessageKind,
    messageSourceId?: string,
    text?: string,
    location?: Location,
    formattedAddress?: string,
    downloadUrl?: string
  ): Message {
    const message: Message = {
      id: `new-${Date.now().toString()}`,
      tenantId,
      conversationId,
      participantId,
      sequence: null,
      kind,
      location,
      formattedAddress,
      createdAt: new Date(),
      updatedAt: new Date(),
      ...(text && { text }),
      sourceId: messageSourceId,
    };

    if (downloadUrl) {
      message.asset = { downloadUrl };
    }

    return message;
  }

  createCreateMessageRequest(
    kind: MessageKind,
    participantId: string,
    text?: string,
    location?: Location
  ): MessagePostRequest {
    // optional object property assignment
    // https://stackoverflow.com/questions/11704267/in-javascript-how-to-conditionally-add-a-member-to-an-object
    return {
      kind,
      participantId: participantId,
      ...(text && { text }),
      ...(location && { location }),
    };
  }
}
